import React, { useEffect, useState } from 'react';
import { useController, Control } from 'react-hook-form';
import styled from 'styled-components';
import CustomDatePickerV2 from './CustomDatePickerV2';
import { DatePicker } from 'antd';
import moment from 'moment';
import { icon_project_calendar } from 'components/base/images';
import { createGlobalStyle } from 'styled-components';

interface DatePickerControllerProps {
  control: Control;
  name: string;
  open?: boolean;
  disabled?: boolean;
  required?: boolean;
  defaultValue?: moment.Moment;
  placeholder?: string;
  showToday?: boolean;
  inputRef?: any;
  onOpenChange?: (open: boolean) => void;
}

function DatePickerController({
  control,
  name,
  open = false,
  disabled = false,
  required = false,
  defaultValue = moment(),
  placeholder,
  showToday,
  inputRef,
  onOpenChange,
}: DatePickerControllerProps) {
  const {
    field,
    meta: { invalid },
  } = useController({
    name,
    control,
    rules: { required: required },
  });

  const [isOpenPicker, setIsOpenPicker] = useState(false);

  const handleBlur = () => {
    setIsOpenPicker(false);
  };

  const handleOpenChange = (open: boolean) => {
    setIsOpenPicker(open);
    if (!!onOpenChange) onOpenChange(open);
  };

  useEffect(() => {
    setIsOpenPicker(open);
  }, [open]);

  return (
    <StyledDatePickerController>
      <DatePicker
        open={isOpenPicker}
        disabled={disabled}
        value={field.value}
        className="datePickerController__input_box"
        defaultValue={defaultValue}
        placeholder={placeholder}
        showToday={showToday}
        onChange={field.onChange}
        suffixIcon={null}
        ref={inputRef}
        onBlur={handleBlur}
        onOpenChange={handleOpenChange}
      />
      <GlobalStyles />
    </StyledDatePickerController>
  );
}

const StyledDatePickerController = styled.div`
  display: flex;
  column-gap: 10px;
  width: 100%;
  .datePickerController__input_box {
    width: 100%;
    height: 50px;
    border: 1px solid #e1e1e7;
    border-radius: 2px;
    &.ant-picker-focused {
      box-shadow: none;
    }
    &.ant-picker-disabled {
      background: #f9f9fb;
      color: #888;
    }
    .ant-picker-input {
      input {
        font-size: 20px;
        font-weight: 400;
        color: #222;
      }
    }
  }
  .datePickerController__button_box {
    width: 50px;
    height: 50px;
    border-radius: 2px;
    border: 1px solid #e1e1e7;
  }
`;

const GlobalStyles = createGlobalStyle`
  .ant-picker-dropdown {
    z-index: 1300 !important;
  }
  .ant-picker {
    border-radius: 5px;
    &.ant-picker-focused {
      box-shadow: none;
    }
  }
  .ant-picker-content {
    .ant-picker-cell-today,
    .ant-picker-cell-selected {
      .ant-picker-cell-inner {
        border-radius: 50%;
        &:before {
          border-radius: 50% !important;
        }
      }
    }
  }
`;

export default React.memo(DatePickerController);
